import { render, staticRenderFns } from "./PasswordForgotForm.vue?vue&type=template&id=9b6f5f18"
import script from "./PasswordForgotForm.vue?vue&type=script&lang=js"
export * from "./PasswordForgotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports